export default __webpack_public_path__ + "static/examedi-logo-2023-becf39f75ef992f9994acfb2cf1c0b70.png";